"use client";

import { useLang } from "@/contexts/language-context";
import AnimatedSection, { AnimatedElement } from "@/components/marketing/AnimatedSection";
import { Wifi, CreditCard, Zap } from "lucide-react";

const specs = [
  {
    icon: Zap,
    color: "bg-redy-orange/10 text-redy-orange",
    title: { en: "Contactless", es: "Sin contacto" },
    desc: {
      en: "Apple Pay, Google Pay, tap cards. A quick tap and your customer is done.",
      es: "Apple Pay, Google Pay, tarjetas tap. Un tap rápido y tu cliente termina.",
    },
  },
  {
    icon: CreditCard,
    color: "bg-redy-blue/10 text-redy-blue",
    title: { en: "Chip & Swipe", es: "Chip y banda" },
    desc: {
      en: "Chip and swipe for the major card brands — Visa, Mastercard, Amex, Discover.",
      es: "Chip y banda para las marcas principales — Visa, Mastercard, Amex, Discover.",
    },
  },
  {
    icon: Wifi,
    color: "bg-redy-green/10 text-redy-green",
    title: { en: "Wireless", es: "Inalámbrico" },
    desc: {
      en: "The card reader pairs with your iPad over Bluetooth. No cables at the counter.",
      es: "El lector se empareja con tu iPad vía Bluetooth. Sin cables en el mostrador.",
    },
  },
];

export default function HardwareSpecs() {
  const { t } = useLang();

  return (
    <AnimatedSection className="py-16 px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {specs.map((spec, i) => {
            const Icon = spec.icon;
            return (
              <AnimatedElement
                key={i}
                delay={0.1 * i}
                className="bg-white border border-black/5 rounded-[32px] p-8 hover:shadow-lg hover:border-black/10 transition-all"
              >
                <div
                  className={`w-14 h-14 rounded-[18px] flex items-center justify-center mb-6 ${spec.color}`}
                >
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-[20px] font-black text-redy-charcoal mb-3">
                  {t(spec.title.en, spec.title.es)}
                </h3>
                <p className="text-[14px] font-medium text-redy-secondary leading-relaxed">
                  {t(spec.desc.en, spec.desc.es)}
                </p>
              </AnimatedElement>
            );
          })}
        </div>
      </div>
    </AnimatedSection>
  );
}
